import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import ClientView from '@/views/ClientView.vue'
import DashboardView from '@/views/DashboardView.vue'
import HardwareView from '@/views/HardwareView.vue'
import AdminClient from '@/views/AdminClient.vue'
import DeploymentView from '@/views/DeploymentView.vue'
import AffichageTvView from '@/views/Affichage-tvView.vue'
import MaintenanceView from '@/views/MaintenanceView.vue'
import ConfigurationView from '@/views/ConfigurationView.vue'
import SuperAdminView from '@/views/SuperAdminView.vue'
import SettingsView from '@/views/SettingsView.vue'
import UserClient from '@/views/UserClient.vue'
import RapportIntervention from '@/views/RapportIntervention.vue'
import RapportTicketing from '@/views/RapportTicketing.vue'
import KioskView from '@/views/KioskView.vue'
import TicketTv from '@/views/TicketTv.vue'
import ScreenView from '@/views/ScreenView.vue'
import CountersUsers from '@/views/CountersUsers.vue'
import TicketView from '@/views/TicketView.vue'
import CallingView from '@/views/CallingView.vue'
import BackOfficeView from '@/views/BackOfficeView.vue'
import { isTokenExpired } from '@/utils/authCheck'
const routes = [
  { path: '/login', name: 'login', component: LoginPage },
   { path: '/tickets', name: 'TicketView', component: TicketView },
   { path: '/calling', name: 'calling', component: CallingView },
   { path: '/back-office', name: 'back-office', component: BackOfficeView },
   { path: '/client', name: 'client', component: ClientView },
   { path: '/rapport-intervention', name: 'rapport-intervention', component: RapportIntervention },
   { path: '/rapport-ticketing', name: 'rapport-ticketing', component: RapportTicketing },
    { path: '/user-client', name: 'user-client', component: UserClient },
    { path: '/hardware', name: 'hardware', component: HardwareView },
  { path: '/', name: 'dashboard', component: DashboardView },
  { path: '/deployment', name: 'deployment', component: DeploymentView },
  { path: '/superadmin', name: 'superadmin', component: SuperAdminView },
  { path: '/settings', name: 'settings', component: SettingsView },
    { path: '/maintenance', name: 'maintenance', component: MaintenanceView },
     { path: '/configuration', name: 'configuration', component: ConfigurationView },
   { path: '/admin-client', name: 'admin-client', component: AdminClient },
    { path: '/affichage-tv', name: 'affichage-tv', component: AffichageTvView },
     { path: '/waitingRoom', name: 'waitingRoom', component: TicketTv },
      { path: '/screen', name: 'screen', component: ScreenView },
      { path: '/Counter-User', name: 'Counter-User', component: CountersUsers },

      { path: '/kiosk', name: 'kiosk', component: KioskView },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ✅ Protection des routes avec vérification d'expiration de token
router.beforeEach((to, from, next) => {
  console.log('[Router] Navigation vers:', to.path);

  // 1. Liste des pages publiques
  const publicPages = ['/login', '/waitingRoom', 'waitingroom']

  // 2. Vérifier si la route nécessite une authentification
  const authRequired = !publicPages.includes(to.path)

  // 3. Si pas d'auth requise, laisser passer
  if (!authRequired) {
    console.log('[Router] ✅ Page publique, accès autorisé');
    return next()
  }

  // 4. Récupération du token
  const token = localStorage.getItem('userToken')
  console.log('[Router] 🔑 Token présent:', !!token);

  // 5. Vérifier la présence du token
  if (!token) {
    console.warn('[Router] ⚠️ Aucun token, redirection vers /login');
    return next('/login')
  }

  // 6. Vérifier l'expiration du token
  const expired = isTokenExpired(token);
  console.log('[Router] ⏰ Token expiré:', expired);

  if (expired) {
    console.warn('[Router] ⚠️ Token expiré, redirection vers /login');
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    return next('/login')
  }

  // 7. Vérifier le rôle de l'utilisateur
  const userData = JSON.parse(localStorage.getItem('userData') || '{}')
  console.log('[Router] 📝 UserData:', userData);
  console.log('[Router] 👤 Role:', userData.role);

  // Accepter plusieurs rôles admin: ADMIN, AGENCY_ADMIN
  const isAdmin = userData.role === 'ADMIN' || userData.role === 'AGENCY_ADMIN'
  const isBackOffice = userData.role === 'BACK_OFFICE'

  // 8. Pages réservées aux admins uniquement
  const adminOnlyPages = [
    '/client',
    '/',
    '/dashboard',
    '/hardware',
    '/deployment',
    '/superadmin',
    '/settings',
    '/maintenance',
    '/configuration',
    '/admin-client',
    '/affichage-tv',
    '/screen',
    '/Counter-User',
    '/rapport-intervention',
    '/rapport-ticketing',
    '/tickets',
    '/calling',
    '/kiosk'
  ]

  // 9. Si l'utilisateur est BACK_OFFICE
  if (isBackOffice) {
    // Rediriger vers /back-office sauf s'il y est déjà
    if (to.path !== '/back-office') {
      console.log('[Router] 🔀 BACK_OFFICE redirigé vers /back-office');
      return next('/back-office')
    }
  }

  // 10. Si l'utilisateur n'est pas admin et tente d'accéder à une page admin
  if (!isAdmin && !isBackOffice && adminOnlyPages.includes(to.path)) {
    console.warn('[Router] ⚠️ Accès refusé, redirection vers /user-client');
    return next('/user-client')
  }

  // 11. Si l'utilisateur n'est pas admin et va sur /, le rediriger vers /user-client
  if (!isAdmin && !isBackOffice && to.path === '/') {
    console.log('[Router] 🔀 Non-admin redirigé vers /user-client');
    return next('/user-client')
  }

  // 10. Token valide, autoriser la navigation
  console.log('[Router] ✅ Token valide, accès autorisé');
  next()
})

export default router
